import { Spine } from "@esotericsoftware/spine-pixi-v8";
import { sound } from "@pixi/sound";
import { isSuperQuickBtnOnGlobal, RespinIndex } from "../../config/GlobalVariableConfig";
import { REEL_DIVIDER, REEL_FRAME, REEL_NUMBERS, REEL_WIDTH, SYMBOL_HEIGHT, SYMBOL_WIDTH, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { DisplayObject, IDisplayObject } from "../../core/displays/DisplayObject";
import { Manager } from "../../core/Manager";
import { reelSpinEmitter } from "../../core/reels/ReelInit";
import { EventConstants } from "../../gameClientEvents/EventConstants";
import { GameEvents } from "../../gameClientEvents/GameEvents";
import { SoundConstants } from "../../gameClientEvents/soundConstants";
import { spinData } from "../../server/getServerResposesFun";
import { ParallelTask, Task } from "../../utils/ParallelTask";


export class HighlightFrames extends DisplayObject {
    private force: boolean = false;
    private toggleFrameOnFSTrigger: boolean = false;

    constructor(config: IDisplayObject) {
        super(config);
        this.setPositionResize(Manager.Orientation || "LANDSCAPE");
        this.init();
        this.subscribeToEvents();
    }

    public init() {
        for (let i = 0; i < REEL_NUMBERS; i++) {
            for (let j = 0; j < SYMBOLS_PER_REEL + 1; j++) {
                this.createWinFrame(i, j);
            }
        }
    }

    public override destroy(options?: boolean | undefined): void {
        this.unSubscribeToEvents();
        super.destroy(options);
    }

    private subscribeToEvents() {
        reelSpinEmitter.on("winsStarted", this.showWinFrames, this);
        reelSpinEmitter.on("resetWins", this.hideframes, this);
        GameEvents.emitter.on(EventConstants.HIDE_FRAMES, this.hideAllFrameFS, this);
    }

    private unSubscribeToEvents() {
        reelSpinEmitter.off("winsStarted", this.showWinFrames, this);
        reelSpinEmitter.off("resetWins", this.hideframes, this);
        GameEvents.emitter.off(EventConstants.HIDE_FRAMES, this.hideAllFrameFS, this);
    }

    private createWinFrame(reelIndex: number, rowIndex: number): void {
        const highlightFrame = Spine.from({
            skeleton: "frameSkel",
            atlas: "frameAtlas"
        });


        if (rowIndex >= SYMBOLS_PER_REEL) {
            return;
        }
        const x =
            REEL_FRAME +
            Math.round(SYMBOL_WIDTH / 2) +
            reelIndex * (REEL_WIDTH + REEL_DIVIDER);

        const y =
            REEL_FRAME +
            Math.round(SYMBOL_HEIGHT / 2) +
            rowIndex * SYMBOL_HEIGHT;

        highlightFrame.x = x;
        highlightFrame.y = y;
        highlightFrame.label = `frame_${reelIndex}_${rowIndex}`
        highlightFrame.visible = false;;
        this.addChild(highlightFrame);
    }

    public highlight(col: number, row: number) {
        const frame = this.getChildByLabel("frame_" + col + "_" + row) as Spine;
        if (frame) {
            frame.visible = true;
            frame.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            frame.skeleton.setToSetupPose();
            sound.play(SoundConstants.MULTIPLIER_BOOST, { volume: 1 });
            frame.state.setAnimation(0, "in", false).listener = {
                complete: () => {
                    frame.state.setAnimation(0, "loop", true);
                    sound.stop(SoundConstants.MULTIPLIER_BOOST);
                    frame.state.clearListeners();
                }

            }
        }
    }

    public hide(col: number, row: number) {
        const frame = this.getChildByLabel("frame_" + col + "_" + row) as Spine;
        if (frame) {
            //frame.state.timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
            frame.visible = false;
            frame.state.clearListeners();
            // frame.state.setAnimation(0, "out", false).listener = {
            //     complete: () => {
            //         frame.visible = false;
            //         frame.state.clearListeners();
            //     }

            // }
        }
    }

    private async showWinFrames() {
        let winObjects: number[][] = spinData.respins[RespinIndex.value].featureData?.highlightPositions;
        if (RespinIndex.value > 0) {
            let type = spinData.respins[RespinIndex.value - 1].type;
            if (type === "feature_enter" && this.parent.label === "bg_reelframe") {
                this.toggleFrameOnFSTrigger = !this.toggleFrameOnFSTrigger;
            }
        }

        let arr: Task<any>[] = [];

        if (!winObjects || this.toggleFrameOnFSTrigger) return Promise.resolve();

        winObjects.forEach((winObject) => {
            if (!winObject) return;

            const reelNum: number = winObject[0];
            const posNum: number = winObject[1];
            const frame = this.getChildByLabel("frame_" + reelNum + "_" + posNum) as Spine;

            if (frame && !frame.visible) {
                let timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;

                arr.push(() => new Promise<void>(() => {
                    frame.visible = true;
                    frame.state.timeScale = timeScale;
                    frame.state.setAnimation(0, "in", false);
                    frame.state.apply(frame.skeleton);
                }));
            }
        });

        if (arr.length === 0) return Promise.resolve();
        const masterTask = new ParallelTask(arr);
        return await masterTask.execute({ stagger: 50 });
    }

    public hideAllFrameFS() {
        this.force = true;
        //this.hideframes();
        for (let i = 0; i < REEL_NUMBERS; i++) {
            for (let j = 0; j < SYMBOLS_PER_REEL + 1; j++) {
                const frame = this.getChildByLabel("frame_" + i + "_" + j) as Spine;
                if (frame) {
                    frame.visible = false;
                    frame.state.clearListeners();
                }
            }
        }
    }
    //@ts-ignore
    private hideframes() {
        console.log('hideWinframes children:', this.children);
        const respinType = spinData.respins[RespinIndex.value]?.type;
        if (!respinType || respinType && (respinType === "reveal" || respinType === "collapse" || respinType === "windmill_reveal") || this.force) {
            this.force = false;
            let arr: Task<any>[] = [];
            for (const frame of this.children) {
                if (!frame) continue;
                arr.push(() => new Promise<void>(() => {
                    let listener = {
                        complete: () => {
                            (frame as Spine).state.removeListener(listener);
                            (frame as Spine).visible = false;
                        }
                    };

                    //(frame as Spine).state.addListener(listener);
                    //(frame as Spine).state.setAnimation(0, "out", false);
                    (frame as Spine).state.removeListener(listener);
                    (frame as Spine).visible = false;
                }));

            }
            const masterTask = new ParallelTask(arr);
            masterTask.execute({ stagger: 10 });
        }
    }
}
